import { useAppSelector, useAppTranslation } from "@/utils";
import { InfoCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface GetOrderUnAvailableProps {
  url?: string;
  name?: string;
  errorMessages?: { code: string; message: string }[];
  onRetry?: () => void;
  onRetryLoading?: boolean;
}

const PayGetOrderUnAvailable = (props: GetOrderUnAvailableProps) => {
  const { t } = useAppTranslation();

  const shopInfo = useAppSelector((state) => state.dashboardPersist.shopInfo);
  const order = useAppSelector((state) => state.bnplConsumer.order);
  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex flex={1} vertical justify="center" align="center" gap={"large"}>
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />
        <Flex vertical gap={"small"} align="center">
          {/* <Typography.Title level={5} className="tw:m-0! tw:font-medium">
            {t("pay.getOrder.unAvailable.title")}
          </Typography.Title> */}
          {props?.errorMessages?.length
            ? props.errorMessages.map((item, index) => (
                <Typography.Paragraph key={index} type="secondary" className="tw:m-0! tw:text-center!">
                  {item.message}
                </Typography.Paragraph>
              ))
            : null}
        </Flex>
        {props.onRetry ? (
          <Button
            type="link"
            icon={<PhRArrowCounterClockwise width={14} height={14} />}
            onClick={async () => {
              if (!props.onRetry) return;
              await props.onRetry();
            }}
            loading={props.onRetryLoading ?? false}
          >
            {t("common.retry")}
          </Button>
        ) : null}
      </Flex>
      <Flex gap={"middle"} className="tw:mt-auto tw:w-full">
        {props.url ? (
          <a href={props.url} className="tw:w-full">
            <Button block>{props.name ? t("pay.returnTo", { name: props.name }) : t("common.returnToShop")}</Button>
          </a>
        ) : (
          <a href={order.merchantRedirectUrl ?? shopInfo.url} className="tw:w-full">
            <Button block>{t("pay.returnTo", { name: order.merchantName ?? shopInfo.name })}</Button>
          </a>
        )}
      </Flex>
    </Flex>
  );
};

export default PayGetOrderUnAvailable;
